import { z } from "zod"

export const TwoFactorSetupDataSchema = z.object({
  secret: z.string(),
  provisioning_uri: z.string(),
  qr_code_url: z.string().url(),
  full_name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  username: z.string().nullable().optional(),
})

export const TwoFactorVerifyResponseSchema = z.object({
  two_fa_type: z.enum(["email", "authenticator"]).nullable().optional(),
})

export type TwoFactorSetupData = z.infer<typeof TwoFactorSetupDataSchema>
export type TwoFactorVerifyResponse = z.infer<typeof TwoFactorVerifyResponseSchema>
